<template>
  <div class="column is-4">
    <CardProducto
      :titulo="oferta.nombreCompleto"
      :rutaInferior="rutaInferior"
      :imageSrc="imageSrc"
      :precio="precio"
    />
  </div>
</template>

<script>
import CardProducto from '@/components/Productos/CardProducto.vue'

export default {
  name: 'Producto',
  props: {
    oferta: {
      type: Object,
      required: true
    },
    packFoto: {
      type: Object,
      required: true
    }
  },
  components: {
    CardProducto
  },
  computed: {
    imageSrc () {
      if (!this.oferta.imagenUrl) return ''
      const url = this.oferta.imagenUrl
      const isAbsolute = /^https?:\/\//i.test(url) || url.startsWith('//')
      if (isAbsolute) return url
      const base = this.imagenBaseUrl
      if (!base) return url
      return `${base}/${url}`
    },
    imagenBaseUrl () {
      const base = process.env.VUE_APP_STATIC_URL || process.env.VUE_APP_URL_API || ''
      return base.endsWith('/') ? base.slice(0, -1) : base
    },
    precio () {
      let precio = ''
      switch (this.oferta.tipoPackFoto) {
        case this.$constantes.ofertas.tiposPackFotos.MIN_MAX_FIJO:
          precio = {
            valor: `$${this.packFoto.precio}`,
            moneda: 'ARS',
            formato: 'simple'
          }
          break
        case this.$constantes.ofertas.tiposPackFotos.DINAMICO:
          precio = {
            valor: `Entre $${this.oferta.packFotosHabilitados[this.oferta.packFotosHabilitados.length - 1].precio} y $${this.oferta.packFotosHabilitados[0].precio} por foto`,
            moneda: 'ARS',
            formato: 'simple'
          }
          break
        case this.$constantes.ofertas.tiposPackFotos.MIN_MAX_POR_UNIDAD:
          precio = {
            valor: `$${this.packFoto.precio} por foto`,
            moneda: 'ARS',
            formato: 'simple'
          }
          break
        case this.$constantes.ofertas.tiposPackFotos.FIJO:
          precio = {
            valor: `$${this.packFoto.precio}`,
            moneda: 'ARS',
            formato: 'simple'
          }
          break
      }
      return precio
    },
    rutaInferior () {
      if (this.oferta.tipoPackFoto === this.$constantes.ofertas.tiposPackFotos.DINAMICO) {
        return {
          ruta: {
            name: 'subir-fotos-oferta',
            params: {
              id: this.oferta.id
            }
          },
          texto: 'Comprar'
        }
      } else {
        return {
          ruta: {
            name: 'subir-fotos-pack',
            params: {
              id: this.packFoto.id
            }
          },
          texto: 'Comprar'
        }
      }
    }
  }
}
</script>
